import {Component, Input, ViewChild} from '@angular/core';
import {BaseGenericComponent} from '../../BaseGenericComponent';
import {User, UserFilter} from '../../../models/User';
import {UserDataSource} from '../../../datasources/UserDataSource';
import {MatPaginator, MatSort} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/api/UserService';
import {GeneralService} from '../../../services/api/GeneralService';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent extends BaseGenericComponent<User, UserFilter, UserDataSource> {

  @Input() showOnlyActive: boolean;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(route: ActivatedRoute, router: Router, generalService: GeneralService, private userService: UserService) {
    super(route, router, generalService, User, UserDataSource);
    this.displayedColumns = ['surname', 'name', 'username', 'email', 'phone', 'actions'];
  }

  onInit() {
    this.showOnlyActive = this.showOnlyActive == null ? true : this.showOnlyActive;
  }

  beforeAfterViewInit() {
    if (!this.filter) {
      this.filter = new UserFilter();
    }
    console.log(this.showOnlyActive);
    this.filter.onlyActive = this.showOnlyActive;

    this.dataSource.showOnlyActive = this.showOnlyActive;
  }

  handleDelete(id: number) {
    // this is not used. use toogleDelete instead
  }

  toggleDelete(user: User) {
    if (confirm('Sicuro di voler ' + (user.active ? 'dis' : 'ri') + 'attivare l\'utente selezionato?')) {
      this.userService.delete(user.id)
        .then(() => this.loadData());
    }
  }

}
